// extracted by mini-css-extract-plugin
export default {"ma-modal":"MaModal_ma-modal__3I2-5"};